import { useEffect, useState } from 'react'
import GetIcon from "../../../../utils/Icon";
import PaymentModal from './Payments/PaymentModal';
import ItemTable from './General_Details/ItemTable';
import Button from "../../../../Core/Button/Button";
import printerimg from "../../../../assets/print.png"
import PaymentDetailsTab from './Payments/PaymentDetailsTab';
import DiscountSection from './General_Details/DiscountSection';
import FormLayoutTwo from '../../../../Core/Layout/FormLayoutTwo';
import InvoiceTotalsBox from './General_Details/InvoiceTotalsBox';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import GeneralDetailsTab from './General_Details/GeneralDetailsTab';
import TaxAndChargesTable from './General_Details/TaxAndChargesTable';
import AddressAndContactTab from './Address_Contact/AddressAndContactTab';
import PaymentMethodSelector from './General_Details/PaymentMethodSelector';
import { useGetSelectedCompanyQuery } from '../../../../store/api/companyapi';
import { usePostDefaultTaxandChargeApiMutation, usePostSearchFilterApiMutation, usePostValidateLinkApiMutation } from '../../../../store/api/auricsuite_globalapi';
import PartSalesModal from './Payments/PartSalesModal';
import { useGetDoctypeDataQuery, usePostSaveDocMutation } from '../../../../store/api/globalapi';
import { useLazyGetPaymentDetailsQuery, usePostAdvancePaymentApiMutation, usePostShippingAddressApiMutation } from '../../../../store/api/salesinvoiceAuricApi';
import MoreInfoTab from './More_Info/MoreInfoTab';
import { parseERPNextError } from '../../../../utils/parseERPNextError';

function Center() {
	const [errorMessage, seterrorMessage] = useState('');
	const [errorType, seterrorType] = useState("Error")
	const [isErrorVisible, setisErrorVisible] = useState(false);
	const [Rows, setRows] = useState([]);
	const [docDataFromApi, setdocDataFromApi] = useState({});
	const [loader, setloader] = useState(true);
	const [priceList, setpriceList] = useState([]);
	const [activeTab, setActiveTab] = useState('tab1');
	const [paymentType, setpaymentType] = useState(null);
	const [customer_List, setcustomer_List] = useState([]);
	const [partSalesState, setpartSalesState] = useState({});
	const [sales_Person_List, setsales_Person_List] = useState([]);
	const [cost_center_List, setcost_center_List] = useState([]);
	const [project_List, setproject_List] = useState([]);
	const [currency_List, setcurrency_List] = useState([]);
	const [billingAddress_List, setbillingAddress_List] = useState([]);
	const [advance_Payment_List, setadvance_Payment_List] = useState([]);
	console.log("advan nt_List",advance_Payment_List);
	const [TaxandCharges_List, setTaxandCharges_List] = useState([]);
	const [territory_List, setterritory_List] = useState([]);
	const [sales_Partner_List, setsales_Partner_List] = useState([]);
	const [shipping_dispatch_address_List, setshipping_dispatch_address_List] = useState([]);
	const [billingContactPerson_List, setbillingContactPerson_List] = useState([]);
	const [companyContactPerson_List, setcompanyContactPerson_List] = useState([]);
	const [showPaymentModal, setShowPaymentModal] = useState(false);
	const [showPartSalesModal, setShowPartSalesModal] = useState(false);
	const [GetDefaultTaxandCharges] = usePostDefaultTaxandChargeApiMutation();
	const [GetShippingAddressApi] = usePostShippingAddressApiMutation();
	const [getcustomerApi] = usePostSearchFilterApiMutation();
	const [postSalesInvoice] = usePostSaveDocMutation();
	const [LinkApi] = usePostValidateLinkApiMutation();
	const getcompany = useGetSelectedCompanyQuery();
	const defaultComapny = getcompany?.data?.message?.data?.company;
	const defaultCurrency = getcompany?.data?.message?.data?.default_currency;
	const defaultCostCenter = getcompany?.data?.message?.data?.cost_center;
	const [triggerPaymentDetail] = useLazyGetPaymentDetailsQuery();


	const paymentTypes = ["Cash", "UPI", "Cheque", "CreditCard", "OldGold"];

	const apiNameMap = {
		CreditCard: "Credit Card",
		OldGold: "Old Gold",
	};

	useEffect(() => {
		async function loadAll() {
			try {
				const promises = paymentTypes.map((type) => {
					const apiName = apiNameMap[type] || type;
					return triggerPaymentDetail({
						doctype: "Mode of Payment",
						name: apiName,
					}).unwrap();
				});

				const results = await Promise.all(promises);
				console.log("API payment detail results:", results);

				const allAccountPaidTo = {};
				results.forEach((res, idx) => {
					const type = paymentTypes[idx];
					// Assuming structure: res.message.accounts[0].default_account
					const account = res?.message?.accounts?.[0]?.default_account || "";
					allAccountPaidTo[type] = account;
				});

				setpaymentDetails((prev) => {
					const updated = { ...prev };
					paymentTypes.forEach((type) => {
						updated[type] = {
							...prev[type],
							account_paid_to: allAccountPaidTo[type],
						};
					});
					return updated;
				});
			} catch (err) {
				console.error("Error loading payment details:", err);
				// Optionally: show error / fallback behavior
			}
		}

		loadAll();
	}, []);





	const [paymentDetails, setpaymentDetails] = useState({
		Cash: { amount: 0, account_paid_to: '' },
		PartSale: { amount: 0, account_paid_to: '' },
		UPI: { amount: 0, upiId: "", account_paid_to: '' },
		CreditCard: { amount: 0, cardNo: "", account_paid_to: '' },
		OldGold: { amount: 0, accountPaidTo: "", account_paid_to: '' },
		Cheque: { amount: 0, cheque_reference_no: "", cheque_reference_date: "", account_paid_to: '' },
	});

	const tabs = [
		{ id: 'tab1', label: 'General Details' },
		{ id: 'tab2', label: 'Payments' },
		{ id: 'tab3', label: 'Address & Contact' },
		{ id: 'tab4', label: 'More Info' },
	];

	const place_of_supply_List = [
		{ value: "01-Jammu and Kashmir" },
		{ value: "02-Himachal Pradesh" },
		{ value: "03-Punjab" },
		{ value: "04-Chandigarh" },
		{ value: "05-Uttarakhand" },
		{ value: "06-Haryana" },
		{ value: "07-Delhi" },
		{ value: "08-Rajasthan" },
		{ value: "09-Uttar Pradesh" },
		{ value: "10-Bihar" },
		{ value: "11-Sikkim" },
		{ value: "12-Arunachal Pradesh" },
		{ value: "13-Nagaland" },
		{ value: "14-Manipur" },
		{ value: "15-Mizoram" },
		{ value: "16-Tripura" },
		{ value: "17-Meghalaya" },
		{ value: "18-Assam" },
		{ value: "19-West Bengal" },
		{ value: "20-Jharkhand" },
		{ value: "21-Odisha" },
		{ value: "22-Chhattisgarh" },
		{ value: "23-Madhya Pradesh" },
		{ value: "24-Gujarat" },
		{ value: "26-Dadra and Nagar Haveli and Daman and Diu" },
		{ value: "27-Maharashtra" },
		{ value: "29-Karnataka" },
		{ value: "30-Goa" },
		{ value: "31-Lakshadweep Islands" },
		{ value: "32-Kerala" },
		{ value: "33-Tamil Nadu" },
		{ value: "34-Puducherry" },
		{ value: "35-Andaman and Nicobar Islands" },
		{ value: "36-Telangana" },
		{ value: "37-Andhra Pradesh" },
		{ value: "38-Ladakh" },
		{ value: "96-Other Countries" },
		{ value: "97-Other Territory" }
	];

	const [generalDetails, setgeneralDetails] = useState({
		series: '',
		customer: '',
		currency: '',
		sales_person: '',
		cost_center: '',
		price_list: '',
		date_of_visit: '',
		taxcategory: '',
		territory: '',
		stct: '',
		ipr: false,
		company: defaultComapny?.split(" - ")[0],
		discountOn: '',
		discountValue: '',
		discountAmount: '',
		discountBool: false,
		posting_date: new Date().toISOString().split("T")[0], // YYYY-MM-DD
		posting_time: new Date().toTimeString().split(" ")[0].slice(0, 8), // HH:mm:ss
		payment_due_date: null,
		billing_address: null,
		shipping_address: null,
		place_of_supply: null,
		full_shipping_address: null,
		billing_contact_person: null,
		shipping_dispatch_address: null,
		company_address: null,
		company_Address_Person: null,
		gstDetails: {},
		debit_to: null,
		is_opening_entry: 'No',
		sales_partner: '',
		commission_rate: null,
		amount_eligible_for_commission: null,
		total_commission: null,
		status:'New'
	});
	console.log("check sales invoice data is here or not",generalDetails);
	const {data:salesInvoiceDataFromApi,refetch,isloading} = useGetDoctypeDataQuery({doctype:"Sales Invoice",name:generalDetails?.name});
   console.log("check sales invoice Data",salesInvoiceDataFromApi);
	useEffect(()=>{
      if(salesInvoiceDataFromApi){
          setdocDataFromApi(salesInvoiceDataFromApi?.docs?.[0])
		  updateGenderalDetails("modified",salesInvoiceDataFromApi?.docs?.[0]?.modified);
		  updateGenderalDetails("creation",salesInvoiceDataFromApi?.docs?.[0]?.creation);
	  }
	},[salesInvoiceDataFromApi])


	useEffect(()=>{
      if(generalDetails?.name){
		refetch();
	  }
	},[generalDetails.name])
	console.log("generalDetailsgeneralDetailsgeneralDetailsgeneralDetailsgeneralDetails",generalDetails);

	const updateGenderalDetails = (field, value) => { setgeneralDetails(prev => ({ ...prev, [field]: value })); };




	// Calculations
	const totalPriceWithTax = Rows.reduce((sum, item) => sum + parseFloat(item.rate || 0), 0);
	const totalPaidAmount = Object.values(paymentDetails).reduce((sum, pay) => sum + (pay.amount || 0), 0);
	const totalAdvancePayment = advance_Payment_List.reduce((sum, item) => sum + parseFloat(item.allocated_amount), 0);
	const totalTax = !TaxandCharges_List ? 0 : TaxandCharges_List.reduce((sum, item) => sum + parseFloat(item?.amount), 0);

	const ListAPI = async (value = "", doctype, setList, extrafield = null) => {
		try {
			const formData = new FormData();
			formData.append("txt", value);
			formData.append("doctype", doctype);
			formData.append("ignore_user_permissions", 0);
			formData.append("reference_doctype", "Sales Invoice");
			formData.append("page_length", 10);
			if (extrafield) {
				Object.entries(extrafield).forEach(([key, val]) => {
					if (typeof val === "object") {
						formData.append(key, JSON.stringify(val));
					} else {

						if (typeof val === "array") {
							formData.append(key, JSON.stringify(val));
						} else {
							formData.append(key, val);
						}
					}
				});
			}
			const response = await getcustomerApi(formData).unwrap();
			setList(response?.message || []);
		} catch (error) {
			console.log("check customer list error", error);
		}
	};

	// Fetch Default Value For GeneralDetails
	useEffect(() => {
		setgeneralDetails({
			series: '',
			customer: '',
			currency: defaultCurrency,
			sales_person: '',
			cost_center: '',
			price_list: 'Standard Selling',
			date_of_visit: '',
			taxcategory: '',
			stct: '',
			ipr: false,
			company: defaultComapny?.split(" - ")[0],
			discountOn: '',
			discountValue: '',
			discountAmount: '',
			discountBool: false,
			posting_date: new Date().toISOString().split("T")[0],
			posting_time: new Date().toTimeString().split(" ")[0].slice(0, 8),
			payment_due_date: null,
			status:'New'

		});
	}, [defaultComapny])

	// When Item Price Change
	useEffect(() => {
		setgeneralDetails((item) => ({ ...item, discountOn: 'Grand Total', discountAmount: '', discountValue: '', discountBool: false, }))
		setpaymentDetails((prev) => {
			const updated = {};
			Object.keys(prev).forEach((key) => {
				updated[key] = {
					...prev[key],
					amount: 0
				};
			});
			return updated;
		});
	}, [totalPriceWithTax])

	// When Additional Discount Change
	useEffect(() => {
		setpaymentDetails((prev) => {
			const updated = {};
			Object.keys(prev).forEach((key) => {
				updated[key] = {
					...prev[key],
					amount: 0
				};
			});
			return updated;
		});

		if (generalDetails.customer && advance_Payment_List.length > 0) {
			GetAdvancePaymentApi();
		}
	}, [generalDetails.discountAmount])


	// When commission rate change
	useEffect(() => {
		if (generalDetails.commission_rate) {
			const commissionRate = parseFloat(generalDetails.commission_rate) || 0;
			let amountEligible = parseFloat(totalPriceWithTax) || 0;
            console.log("check this section is getting it or not",totalPriceWithTax);
			// If discount is applied as percentage, calculate discount amount
			if (generalDetails.discountOn === "Net Total" && generalDetails.discountValue) {
				const discountPercentage = parseFloat(generalDetails.discountValue) || 0;
				const discountAmount = (amountEligible * discountPercentage) / 100;
				amountEligible -= discountAmount;
			}

			// Calculate total commission
			const totalCommission = (amountEligible * commissionRate) / 100;

			// Update the general details
			updateGenderalDetails("amount_eligible_for_commission", amountEligible.toFixed(2));
			updateGenderalDetails("total_commission", totalCommission.toFixed(2));
		} else {
			// Reset if no commission rate
            console.log("check this section is getting it or not 222",totalPriceWithTax); 
			updateGenderalDetails("amount_eligible_for_commission", 0);
			updateGenderalDetails("total_commission", 0);
		}
	}, [generalDetails.commission_rate, totalPriceWithTax]);


	useEffect(() => {
		updateGenderalDetails("commission_rate", 0);
		updateGenderalDetails("amount_eligible_for_commission", 0);
		updateGenderalDetails("total_commission", 0);
	}, [generalDetails.discountValue, generalDetails.discountOn])

	// For Tax and Charges 
	useEffect(() => {
		const TandC = async () => {
			try {
				const formData = new FormData();
				formData.append("currency", getcompany?.data?.message?.data?.default_currency);
				formData.append("party_type", 'Customer');
				formData.append("doctype", 'Sales Invoice');
				formData.append("fetch_payment_terms_template", 1);
				formData.append("party", generalDetails?.customer);
				formData.append("price_list", 'Standard Selling');
				formData.append("company_address", getcompany?.data?.message?.data?.address_list?.[0]?.address_title);
				formData.append("company", defaultComapny?.split(" - ")[0]);
				const response = await GetDefaultTaxandCharges(formData);
				let runningTotal = 0;
				updateGenderalDetails("debit_to", response?.data?.message?.debit_to);
				const updatedTaxes = response.data.message.taxes.map((row) => {
					const rate = parseFloat(row.rate) || 0;
					const baseAmount = parseFloat(generalDetails.discountOn == "Net Total" ? (parseFloat(totalPriceWithTax) - parseFloat(generalDetails.discountAmount || 0)) : parseFloat(totalPriceWithTax)) || 0;
					const amount = (baseAmount * rate) / 100;

					runningTotal += parseFloat(amount);

					return {
						...row,
						tax_category: response.data.message.tax_category,
						taxes_and_charges: response.data.message.taxes_and_charges,
						price_list_currency: response.data.message.price_list_currency,
						debit_to: response.data.message.debit_to,
						amount: parseFloat(amount.toFixed(2)),
						runningTotal,
					};
				});
				setTaxandCharges_List(updatedTaxes);

			} catch (error) {
				console.log("check tax and charges Error", error);
			}
		}
		TandC();
	}, [generalDetails.customer, totalPriceWithTax, generalDetails.discountAmount])

	// For Getting Customer Address
	useEffect(() => {
		ListAPI('', "Address", setbillingAddress_List, { query: "frappe.contacts.doctype.address.address.address_query", filters: { link_doctype: "Customer", link_name: generalDetails.customer } })
		ListAPI('', "Contact", setbillingContactPerson_List, { query: "frappe.contacts.doctype.contact.contact.contact_query", filters: { link_doctype: "Customer", link_name: generalDetails.customer } })
	}, [generalDetails.customer])

	useEffect(() => {

		const billingData = async () => {
			try {
				const formData = new FormData();
				formData.append("doctype", "Address");
				formData.append("fields", JSON.stringify(["gstin", "gst_category"]));
				formData.append("docname", generalDetails.billing_address);
				const response = await LinkApi(formData);

				//  setgstDetails(response.data.message)
				//  setgstDetails(response.data.message)
				updateGenderalDetails("gstDetails", response.data.message)
			} catch (error) {
				console.log("check tax and charges Error", error);
			}
		}
		billingData();

	}, [generalDetails.billing_address])

	useEffect(() => {

		const billingData = async () => {
			try {
				const formData = new FormData();
				formData.append("address_dict", generalDetails.shipping_address);
				const response = await GetShippingAddressApi(formData);
				updateGenderalDetails("full_shipping_address", response.data.message)

				//  setgstDetails(response.data.message)
			} catch (error) {
				console.log("check tax and charges Error", error);
			}
		}
		billingData();

	}, [generalDetails.shipping_address])

	// For Getting Lists 
	useEffect(() => {
		ListAPI("", "Currency", setcurrency_List);
		ListAPI("", "Customer", setcustomer_List);
		ListAPI("", "Territory", setterritory_List);
		ListAPI("", "Sales Person", setsales_Person_List);
		ListAPI("", "Sales Partner", setsales_Partner_List);
		ListAPI("", "Price List", setpriceList, { filters: { selling: 1 } });
		ListAPI("", "Cost Center", setcost_center_List, {
			query: "erpnext.controllers.queries.get_filtered_dimensions",
			filters: {
				dimension: "cost_center",
				company: defaultComapny?.split(" - ")[0]
			}
		}
		);
		ListAPI("", "Project", setproject_List, {
			query: "erpnext.controllers.queries.get_project_name",
			filters: { company: defaultComapny?.split(" - ")[0] }
		}
		);
		ListAPI("", "Address", setshipping_dispatch_address_List, {
			query: "frappe.contacts.doctype.address.address.address_query",
			filters: { link_doctype: "Company", link_name: defaultComapny?.split(" - ")[0] }
		}
		);
		ListAPI('', "Contact", setcompanyContactPerson_List, { query: "frappe.contacts.doctype.contact.contact.contact_query", filters: { link_doctype: "Company", link_name: defaultComapny?.split(" - ")[0] } });
		setloader(false);
	}, [defaultComapny])

	// For Getting Advance Payment
	const [getadvancepaymentapi] = usePostAdvancePaymentApiMutation();
	const GetAdvancePaymentApi = async () => {
		if (generalDetails?.customer) {
			try {
				const formData = new FormData();
				formData.append("doctype", 'Payment Entry');
				formData.append("fields", JSON.stringify(["`tabPayment Entry`.`name`", "`tabPayment Entry`.`owner`", "`tabPayment Entry`.`creation`",
					"`tabPayment Entry`.`modified`", "`tabPayment Entry`.`modified_by`", "`tabPayment Entry`.`_user_tags`",
					"`tabPayment Entry`.`_comments`", "`tabPayment Entry`.`_assign`", "`tabPayment Entry`.`_liked_by`",
					"`tabPayment Entry`.`docstatus`", "`tabPayment Entry`.`idx`", "`tabPayment Entry`.`payment_type`",
					"`tabPayment Entry`.`posting_date`", "`tabPayment Entry`.`mode_of_payment`", "`tabPayment Entry`.`paid_from_account_balance`",
					"`tabPayment Entry`.`paid_to_account_balance`", "`tabPayment Entry`.`paid_amount`", "`tabPayment Entry`.`paid_amount_after_tax`",
					"`tabPayment Entry`.`received_amount`", "`tabPayment Entry`.`received_amount_after_tax`", "`tabPayment Entry`.`unallocated_amount`",
					"`tabPayment Entry`.`status`", "`tabPayment Entry`.`remarks`", "`tabPayment Entry`.`title`", "`tabPayment Entry`.`paid_from_account_currency`",
					"`tabPayment Entry`.`paid_to_account_currency`"]));
				formData.append("filters", JSON.stringify([["Payment Entry", "unallocated_amount", "!=", 0], ["Payment Entry", "title", "=", `${generalDetails.customer}`]]));
				const response = await getadvancepaymentapi(formData);
				const data = response?.data?.message;
				const keys = data?.keys || [];
				const values = data?.values || [];
				const currentDate = new Date().toISOString().split("T")[0];
				const formattedData = values.map((row) => {
					const obj = {};
					keys.forEach((key, i) => {
						obj[key] = row[i];
					});
					obj["allocated_amount"] = 0;
					obj["difference_posting_date"] = currentDate;
					return obj;
				});

				let grandtotal_with_payment_type = ((parseFloat(totalPriceWithTax) + parseFloat(totalTax)) - parseFloat(generalDetails.discountAmount || 0)) - parseFloat(totalPaidAmount || 0);
				if (formattedData.length > 0 && grandtotal_with_payment_type) {
					let remaining = parseFloat(grandtotal_with_payment_type);
					const updatedRows = formattedData.map((row) => {
						let allocated = 0;
						const unallocated = parseFloat(row.unallocated_amount) || 0;

						if (remaining > 0) {
							if (unallocated <= remaining) {
								allocated = unallocated;
								remaining -= unallocated;
							} else {
								allocated = remaining;
								remaining = 0;
							}
						}
						return { ...row, allocated_amount: allocated.toFixed(2) };
					});
					setadvance_Payment_List(updatedRows);
				} else {
					setadvance_Payment_List([]);
				}

			} catch (error) {
				console.log("check tax and charges Error", error);
			}
		} else {
			seterrorMessage(`Pick Customer first`);
			seterrorType("Error");
			setisErrorVisible(true);
		}
	}

	const handleSubmit = async () => {
		if (!generalDetails.customer) {
			seterrorType("Error");
			seterrorMessage("Customer is required");
			setisErrorVisible(true);
			return;
		}

		if (Rows.length === 0) {
			seterrorType("Error");
			seterrorMessage("At least one item is required");
			setisErrorVisible(true);
			return;
		}

		try {
			const grandTotal = parseFloat(totalPriceWithTax) + parseFloat(totalTax);
			const roundedTotal = Math.round(grandTotal);
			const roundingAdjustment = grandTotal - roundedTotal;
            console.log("check api payload is here ",generalDetails)
			const payload = {
				docstatus: 0,
				doctype: "Sales Invoice",
				name: generalDetails?.name,
				company: generalDetails?.company,
				posting_date: generalDetails?.posting_date,
				posting_time: generalDetails?.posting_time,
				sales_partner: generalDetails?.sales_partner,
				commission_rate: generalDetails?.commission_rate == null ? 0 : generalDetails?.commission_rate,
				total_commission: generalDetails?.total_commission == null ? 0 : generalDetails?.total_commission,
				amount_eligible_for_commission: generalDetails?.amount_eligible_for_commission == null ? 0 : generalDetails?.amount_eligible_for_commission,
				is_opening: generalDetails?.is_opening_entry,
				currency: generalDetails?.currency,
				selling_price_list: generalDetails?.price_list,
				price_list_currency: TaxandCharges_List?.[0]?.price_list_currency,
				debit_to: TaxandCharges_List?.[0]?.debit_to,
				update_stock: 1,
				taxes_and_charges: generalDetails?.taxes_and_charges,
				custom_sales_person: generalDetails?.sales_person || "",
				company_address: generalDetails?.company_address || "",
				company_contact_person: generalDetails?.company_Address_Person || "",
				company_gstin: getcompany?.data?.message?.data?.gstin || "",
				company_address_display: getcompany?.data?.message?.data?.address_list?.[0]?.address_display || generalDetails?.full_shipping_address || "",
                shipping_address_name: generalDetails?.shipping_address || "",
				shipping_address: generalDetails?.full_shipping_address || "",
				dispatch_address_name: generalDetails?.shipping_dispatch_address || "",
				items: Rows?.map((item, idx) => ({
				cost_center: generalDetails?.cost_center,
				qty: item?.quantity || 1,
				rate: parseFloat(item?.rate),
				item_code: item?.item_code,
				serial_no: item?.item?.name,
				warehouse: item?.item?.warehouse,
				income_account: item?.res2?.item_defaults?.[0]?.income_account,
				uom: item?.uom,
				})) || [],
				// 🔹 Multiple Payment Entries
				custom_multiple_payment_entry: Object.entries(paymentDetails)
					.filter(([key, value]) => Number(value?.amount) > 0)
					.map(([key, value]) => ({
						posting_date: generalDetails?.posting_date,
						party_type: "Customer",
						party: generalDetails?.customer,
						mode_of_payment: apiNameMap[key] || key,
						paid_amount: value?.amount || 0,
						account_paid_to: value.account_paid_to,
						...value
					})),

				// 🔹 Taxes - Complete structure
				taxes: TaxandCharges_List?.map((tax, idx) => ({
					charge_type: tax?.charge_type,
					cost_center: generalDetails?.cost_center,
					account_head: tax?.account_head,
					description: tax?.description,
					rate: tax?.rate || 0,
				})) || [],
				apply_discount_on: generalDetails?.discountOn,
				additional_discount_percentage: generalDetails?.discountValue,
				territory: generalDetails?.territory,
				discount_amount: parseFloat(generalDetails?.discountAmount) || 0,
				// 🔹 Advances
				advances: advance_Payment_List?.map((adv, idx) => ({
					reference_type: "Payment Entry",
					reference_name: adv?.name,
					remarks: adv?.remarks,
					creation: `${new Date().toISOString().split("T")[0]} ${new Date().toTimeString().split(" ")[0].slice(0, 8)}`,
					ref_exchange_rate:1,
					modified: adv?.modified || 0,
					advance_amount: adv?.paid_amount,
					difference_posting_date: adv?.difference_posting_date,
					allocated_amount: parseFloat(adv?.allocated_amount || 0),
				})) || [],

				customer: generalDetails?.customer || "",
				due_date: generalDetails?.payment_due_date,
				customer_address: generalDetails?.billing_address || "",
				contact_person: generalDetails?.billing_contact_person || "",

				// GST Details
				gst_category: generalDetails?.gstDetails?.gst_category || "",
				billing_address_gstin: generalDetails?.gstDetails?.gstin || "",
				place_of_supply: generalDetails?.place_of_supply || "",
			};

		// 	 if (generalDetails.status !== "New") {
        //     payload.modified = generalDetails?.modified || "";
        //     payload.creation = generalDetails?.creation || "";
        // }

			// VALIDATION: Ensure due_date is after posting_date
			if (payload.due_date && payload.posting_date && payload.due_date <= payload.posting_date) {
				seterrorType("Error");
				seterrorMessage("Due Date must be after Posting Date");
				setisErrorVisible(true);
				return;
			}

			const formData = new FormData();
			formData.append("doc", generalDetails.status == "New" ? JSON.stringify(payload) : JSON.stringify(docDataFromApi));
			formData.append("action", generalDetails.status == "New" ? "Save" : "Submit");


			const response = await postSalesInvoice(formData).unwrap();

            if(response?.docs?.[0]?.name && generalDetails.status == "New"){
				seterrorType("Success");
				seterrorMessage(response?.message || "Invoice saved successfully!");
				setisErrorVisible(true);
			}
			
            if(response?.docs?.[0]?.name){
				updateGenderalDetails("status","Draft");
				updateGenderalDetails("name",response?.docs?.[0]?.name);
			}

			if(response?.message){
				console.log("check thes response is here",response);
				seterrorType("Success");
				seterrorMessage(response?.message || "Invoice saved successfully!");
				setisErrorVisible(true);
			}else{
				if(response?.message?.message){
					if(response?.message?.status == "success"){
						seterrorType("Success");
						seterrorMessage(response?.message?.message || "Invoice saved successfully!");
						setisErrorVisible(true);
					}else{
						seterrorMessage(parseERPNextError({data:{exception:response?.message?.message}}));
					}
				}
			}
		} catch (error) {
			console.error("❌ Error saving invoice:", error);
			seterrorType("Error");
			// seterrorMessage(error?.data?.message || error?.data?.exc || "Failed to save invoice!");
			// if (error.data?._server_messages) {
			// 		try {
			// 		const serverMessages = JSON.parse(error.data._server_messages);
			// 		if (Array.isArray(serverMessages) && serverMessages.length > 0) {
			// 			const firstMessage = JSON.parse(serverMessages[0]);
			// 			seterrorMessage(firstMessage.message || "An error occurred");
			// 		}
			// 		} catch (parseError) {
			// 		// If parsing fails, fall back to exception message
			// 		seterrorMessage(error.data?.exception || error.message || "An error occurred");
			// 		}
			// 	}else if (error.data?.exception) {
			// 		// Extract the meaningful error from the exception string
			// 		const exceptionStr = error.data.exception;
			// 		// Look for the part after "ValidationError: "
			// 		const match = exceptionStr.match(/ValidationError:\s*(.+)/);
			// 		if (match && match[1]) {
			// 		seterrorMessage(match[1].split('\\n')[0]); // Get first line after ValidationError
			// 		} else {
			// 		seterrorMessage(exceptionStr);
			// 		}
			// 	}else {
			// 		seterrorMessage(error.message || "An error occurred while saving the invoice");
			// 	}

				seterrorMessage(parseERPNextError(error));
				
				setisErrorVisible(true);
		}

	};


	return (
		loader ? '' : <FormLayoutTwo
			title="New Sales Invoice"
			breadcrumbs={[
				{
					label: " Sales Invoice List",
					url: "/outbound/outbound/sales-invoice",
				},
			]}
			status={'New'}
			actionButtons={
				<>

					<Button
						className="custom-btn-00989"
						iconName="LuFilePlus2"
						onClick={handleSubmit}
						iconSize={12}
					>
						{generalDetails.status == "New" && "Save"}
						{generalDetails.status == "Draft" && "Submit"}
					</Button>
					<Button
						to="#"
						className="px-2"
						imgSrc={printerimg}
						imgStyle={{ width: '21px' }}
					/>
				</>
			}
		>
			<div style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>

                
				<div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
					<div className="d-flex justify-content-between align-items-end">
						<ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
							{tabs.map((tab) => (
								<li key={tab.id} className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
									<a
										className={`removeborder234 nav-link ${activeTab === tab.id
											? 'active-tab-custom-new text-white'
											: 'tab-inactive-custom'
											} border-radius-top-corner`}
										onClick={() => setActiveTab(tab.id)}
										style={{ cursor: 'pointer' }}
									>
										{tab.label}
										<GetIcon iconName={activeTab === tab.id ? "MdKeyboardArrowDown" : "MdKeyboardArrowRight"} size={15} />
									</a>
								</li>
							))}
						</ul>
						<div className="d-flex align-items-center mb-2 px-3">
							<GetIcon iconName="CgAttachment" size={12} />
							<span className="fw-semibold ms-1" style={{ color: "#4b002b", fontSize: '13px' }}>
								Attachments
							</span>
						</div>
					</div>
				</div>


				<div className=" " style={{ background: '' }}>
					<div className="row">
						<div className="col-12">
							<div >
								{activeTab == "tab1" && <GeneralDetailsTab
										formData={generalDetails}
										onFieldChange={updateGenderalDetails}
										customerData={{ customer_List, refetch_Customer: (e) => { ListAPI(e, "Customer", setcustomer_List) } }}
                                        salesPersonData={{ sales_Person_List, refetch_sales_Person: (e) => { ListAPI(e, "Sales Person", setsales_Person_List) } }}
										costCenterData={{ cost_center_List, refetch_cost_center: (e) => { ListAPI(e, "Cost Center", setcost_center_List, {}) } }}
										currencyData={{ currency_List, refetch_currency: (e) => { ListAPI(e, "Currency", setcurrency_List) } }}
										PriceListData={{ priceList, refetch_priceList: (e) => { ListAPI(e, "Price List", setpriceList, { filters: { selling: 1 } }) } }}
										projectData={{
											project_List, refetch_project: (e) => {
												ListAPI(e, "Project", setproject_List, {
													query: "erpnext.controllers.queries.get_project_name",
													filters: { company: defaultComapny?.split(" - ")[0] }
												})
											}
										}}
								/>}

								{activeTab == "tab2" && <PaymentDetailsTab
										fulldata={generalDetails}
										error={{ seterrorMessage, seterrorType, setisErrorVisible }}
										advancepayment={{ advance_Payment_List, setadvance_Payment_List }}
										totalamount={{ grandtotal: parseFloat(totalPriceWithTax) + parseFloat(totalTax), grandtotal_with_payment_type: ((parseFloat(totalPriceWithTax) + parseFloat(totalTax)) - parseFloat(generalDetails.discountAmount || 0)) - parseFloat(totalPaidAmount || 0), totalPriceWithTax: parseFloat(totalPriceWithTax), totalTax }}
										GetAdvancePaymentApi={GetAdvancePaymentApi}
								/>}

								{activeTab == "tab3" && <AddressAndContactTab
										formData={generalDetails}
										companyinfo={getcompany.data}
										onFieldChange={updateGenderalDetails}
										place_of_supplyData={{ place_of_supply_List }}
										territoryData={{ territory_List, refetch_territory: (e) => { ListAPI(e, "Territory", setterritory_List) } }}
										addressData={{
												billingAddress_List, refetch_billingAddress: (e) => {
													ListAPI(e, "Address", setbillingAddress_List, {
														query: "frappe.contacts.doctype.address.address.address_query",
														filters: { link_doctype: "Customer", link_name: generalDetails.customer }
													})
												}
											}}
										contactPersonData={{
												billingContactPerson_List, refetch_billingAddress_Person: (e) => {
													ListAPI(e, "Contact", setbillingContactPerson_List, {
														query: "frappe.contacts.doctype.contact.contact.contact_query",
														filters: { link_doctype: "Customer", link_name: generalDetails.customer }
													})
												}
											}}	
										companyContactPersonData={{
												companyContactPerson_List, refetch_company_Address_Person: (e) => {
													ListAPI(e, "Contact", setcompanyContactPerson_List, {
														query: "frappe.contacts.doctype.contact.contact.contact_query",
														filters: { link_doctype: "Company", link_name: defaultComapny?.split(" - ")[0] }
													})
												}
											}}
										shippingDispatchAddressData={{
												shipping_dispatch_address_List, refetch_shipping_dispatch_address: (e) => {
													ListAPI(e, "Address", setshipping_dispatch_address_List, {
														query: "frappe.contacts.doctype.address.address.address_query",
														filters: { link_doctype: "Company", link_name: defaultComapny?.split(" - ")[0] }
													})
												}
											}}	
								/>}
															
								{activeTab == "tab4" && <MoreInfoTab
										formData={generalDetails}
										onFieldChange={updateGenderalDetails}
										salesPartnerData={{ sales_Partner_List, refetch_sales_partner: (e) => { ListAPI(e, "Sales Partner", setsales_Partner_List) } }}
								/>}
							</div>
						</div>
					</div>
				</div>

				{activeTab == "tab1" && <div className="px-3 mb-3" style={{ background: '' }}>
					<div className="row">
						<div className="col-12">
							<div >
								<ItemTable
									rows={Rows}
									setRows={setRows}
									formData={generalDetails}
									po_status={""}
									ListAPI={ListAPI}
									error={{ seterrorMessage, seterrorType, setisErrorVisible }}
								/>
							</div>
						</div>
					</div>
				</div>}


				{activeTab == "tab1" && <div className="px-3" style={{ background: '' }}>
					<div className="row">
						<div className="col-12">
							<div >
								<TaxAndChargesTable
									setselected_item_data={[]}
									rows={[]}
									row_list={TaxandCharges_List}
									apidata={generalDetails}
									totalPriceWithTax={parseFloat(totalPriceWithTax) - (generalDetails.discountOn == "Net Total" && parseFloat(generalDetails.discountAmount))}
									setRows={setTaxandCharges_List}
									list_data={() => { }}
									po_status={""}
								/>
							</div>
						</div>
					</div>
				</div>}


				{activeTab == "tab1" && <div className="px-3 my-3" style={{ background: '' }}>
					<div className="row">
						<div className="col-4">
							<InvoiceTotalsBox
								totalTax={totalTax}
								totalPaidAmount={totalPaidAmount}
								totalPriceWithTax={totalPriceWithTax}
								totalAdvancePayment={totalAdvancePayment}
								paymentDetails={paymentDetails}
								fulldata={generalDetails}
								defaultCostCenter={defaultCostCenter}
								updateGenderalDetails={updateGenderalDetails}
							/>
						</div>
						<div className="col-4">


							<DiscountSection
								onFieldChange={updateGenderalDetails}
								fulldata={{ generalDetails, setgeneralDetails }}
								totalamount={parseFloat(totalPriceWithTax) + parseFloat(totalTax)}
								totalTax={parseFloat(totalTax)}
								totalPriceWithTax={parseFloat(totalPriceWithTax)}
								error={{ seterrorMessage, seterrorType, setisErrorVisible }}
							/>


						</div>
						<div className="col-4">
							<PaymentMethodSelector
								togglepopup={(type) => { setpaymentType(type); setShowPaymentModal(!showPaymentModal) }}
								togglepopupPartSales={() => { setShowPartSalesModal(!showPartSalesModal) }}
							/>
						</div>

					</div>
				</div>}





                {/* Payment Methods  */}
				{showPaymentModal &&
					<PaymentModal
						type={paymentType}
						paymentDetails={paymentDetails}
						show={showPaymentModal}
						fulldata={generalDetails}
						totalamountwithDiscount={((parseFloat(totalPriceWithTax) + parseFloat(totalTax)) - parseFloat(generalDetails.discountAmount || 0)) - parseFloat(totalPaidAmount) - parseFloat(totalAdvancePayment || 0)}
						totalamount={((parseFloat(totalPriceWithTax) + parseFloat(totalTax)) - parseFloat(generalDetails.discountAmount || 0)) - parseFloat(totalAdvancePayment || 0)}
						onClose={() => setShowPaymentModal(false)}
						error={{ seterrorMessage, seterrorType, setisErrorVisible }}
						onConfirmPayment={(paymentData) => { setpaymentDetails((prev) => ({ ...prev, [paymentData.type]: paymentData.data })); }}
					/>
				}


				{/* Part Sale Popup */}
				{showPartSalesModal &&
					<PartSalesModal
						type={"Part Sales"}
						show={showPartSalesModal}
						generalDetails={generalDetails}
						paymentDetails={paymentDetails}
						totalamount={totalPriceWithTax + totalTax}
						onClose={() => setShowPartSalesModal(false)}
						partSalesState={{partSalesState,setpartSalesState}}
						error={{ seterrorMessage, seterrorType, setisErrorVisible }}
						onConfirmPayment={(paymentData) => { setpaymentDetails((prev) => ({ ...prev, [paymentData.type]: paymentData.data })); }}
					/>
				}


				{/* Response Popup box */}
				<ApiResponseBox
					poptype={errorType}
					show={isErrorVisible}
					errorMessage={errorMessage}
					onClose={() => setisErrorVisible(false)}
				/>


			</div>
		</FormLayoutTwo>
	)
}

export default Center